import { motion } from "framer-motion";
import { useIntroReady } from "./Intro";

let introPlayed = false;
const EASE = [0.22, 1, 0.36, 1];

export const Logo = ({ light = false, intro = false, className = "h-9 sm:h-10" }) => {
  const v = light ? "light" : "dark";
  const play = intro && !introPlayed;
  const ready = useIntroReady();
  const go = (v) => (!play || ready ? v : undefined);
  const done = () => { introPlayed = true; };
  return (
    <span data-testid="brand-logo" className={`flex items-center ${className}`} role="img" aria-label="GRÜNWIRBEL">
      <motion.img
        data-testid="brand-logo-mark"
        src={`/brand/mark-${v}.png`}
        alt=""
        className="h-full w-auto"
        initial={play ? { rotate: -240, scale: 0.55, opacity: 0 } : false}
        animate={go({ rotate: 0, scale: 1, opacity: 1 })}
        transition={{ duration: 1.5, ease: EASE, delay: 0.15 }}
        onAnimationComplete={play ? done : undefined}
      />
      <motion.img
        src={`/brand/word-${v}.png`}
        alt=""
        className="h-full w-auto"
        initial={play ? { opacity: 0, x: -10 } : false}
        animate={go({ opacity: 1, x: 0 })}
        transition={{ duration: 0.9, ease: EASE, delay: 0.75 }}
      />
    </span>
  );
};
